/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useRef, useContext } from "react";
import { useHistory } from "react-router-dom";
import { GlobalLoaderContext, GlobalAuthContext } from "store/context";
import { FieldArray, Form, Formik } from "formik";
import {
  TableHeader,
  TableColumn,
  Content,
  InlineLabel,
  TableHead,
  TableBody,
  Table,
  FieldText,
  Line,
  ButtonContainer,
  RowFilterIcon,
  ButtonContent,
  LoadContainer
} from "./styles";

import { FitinsurAPI, MessageCenter } from "utils";
import Loader from "components/Loader";
import Layout from "components/Layout";
import { Col, Row } from "components/Grid";
import {
  GridColumnTitle,
  Label,
} from "components/Form";
import Icon from "components/Icon";
import { Button } from "components/index";
import Colors from "constants/Colors";

export default function Product({ match }) {
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const history = useHistory();
  const formik = useRef();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  const [personBasicInfos, setPersonBasicInfos] = useState({
    firstName: '', 
    lastName: '', 
    hierarchy: ''
  });
  const [products, setProducts] = useState([]);

  const columns = [
    {
      title: "PRODUCT NAME",
      value: "productName",
    },
    {
      title: "PRODUCT TYPE",
      value: "productType",
    },
    {
      title: "Action",
    },
  ];

  const getPerson = async () => {
    try {
      loading.start();
      const idPerson = match.params.idPerson;

      if (idPerson) { 
        fitinsur.setAuthToken(authContext.token);
        const response = await fitinsur.requestGetPersonsInfo(idPerson).then(
          (res) => res.json()
        );
        
        if (response.ret_code !== 200) {
          mc.error(response.ret_msg_details);
          loading.stop();
          return;
        }
  
        const basicInfos = {
          firstName: response.ret_value.firstName || '', 
          lastName: response.ret_value.lastName || '', 
          hierarchy: response.ret_value.hierarchy || ''
        }
  
        setPersonBasicInfos(basicInfos);
        loading.stop();
      }
    } catch (error) {
      console.log("Error fetch data: ", error);
      loading.stop();
      mc.error("An error happened, please try again.");
    }
  };

  async function getProducts() {
    try {
      loading.start();
      const idPerson = match.params.idPerson;

      if(idPerson) {
        fitinsur.setAuthToken(authContext.token);
        const response = await fitinsur.requestProductsByIdPerson(idPerson)
          .then((response) => response.json());
        
        if (response.ret_code !== 200) {
          mc.error(response.ret_msg_details);
          loading.stop();
          return;
        }

        setProducts(response.ret_value);
        loading.stop();
      }
    } catch (error) {
      console.log("Error fetch data: ", error);
      loading.stop();
      mc.error("An error happened, please try again.");
    }
  }

  async function loadContent() {
    await getPerson();
    await getProducts();
  }

  useEffect(() => {
    loadContent();
  }, [match.params.idPerson]);


  return (
    <Layout title={personBasicInfos.lastName}>
      <Row>
        <Col>
          <FieldText size={15}>Short Name</FieldText>
          <FieldText bold>{personBasicInfos.firstName}</FieldText>
        </Col>
        <Col>
          <FieldText size={15}>Hierarchy</FieldText>
          <FieldText bold>{personBasicInfos.hierarchy}</FieldText>
        </Col>
      </Row>
      <Row style={{ marginTop: "35px" }}>
        <Col>
          <FieldText bold>PRODUCTS</FieldText>
          <Line />
        </Col>
      </Row>
      <Content>
        <Formik
          innerRef={formik}
          onSubmit={() => {}}
        >
          {() => (
            <Form>
              <RowFilterIcon/>
              <div style={{ marginLeft: 15, marginRight: 15 }}>
                <Table>
                  <TableHead>
                    <tr>
                      {columns.map((column, index) => (
                        <TableHeader
                          key={index}
                          minWidth={column.minWidth}
                          maxWidth={column.maxWidth}
                        >
                          <GridColumnTitle
                            onClick={() =>
                              column.value
                            }
                            style={{
                              cursor: column.value ? "pointer" : "not-allowed",
                            }}
                          >
                            {column.title}
                          </GridColumnTitle>
                        </TableHeader>
                      ))}
                    </tr>
                  </TableHead>
                  <TableBody>
                    <FieldArray
                      name="product"
                      render={() =>
                        products && products.map((product, index) => (
                          <tr key={index}>
                            <TableColumn>
                              <InlineLabel>PRODUCT</InlineLabel>
                              <Label fontSize={12}>{product.productName || ""}</Label>
                            </TableColumn>

                            <TableColumn>
                              <InlineLabel>PRODUCT TYPE</InlineLabel>
                              <Label wordWrap fontSize={12}>
                                {product.productType || ""}
                              </Label>
                            </TableColumn>

                            <TableColumn
                              style={{ textAlign: "right", paddingRight: 10 }}
                            >
                              <InlineLabel>Action</InlineLabel>
                              <Label>
                                <Icon
                                  onClick={() => history.push(`/products/edit-product/person/${match.params.idPerson}/${product.idProduct}`)}
                                  name="edit"
                                  style={{
                                    alignSelf: "left",
                                    cursor: "pointer",
                                  }}
                                />
                              </Label>
                            </TableColumn>
                          </tr>
                        ))
                      }
                    />
                  </TableBody>
                </Table>
              </div>
              <ButtonContainer>
                <ButtonContainer
                  style={{
                    justifyContent: "flex-start",
                    alignItems: "center",
                    paddingBottom: "10px",
                  }}
                >
                  <ButtonContent>
                    <Button
                      forth
                      onClick={() => history.goBack()}
                      style={{ alignSelf: "flex-start" }}
                    >
                      {" "}
                      &lt; Back
                    </Button>
                  </ButtonContent>
                </ButtonContainer>
              </ButtonContainer>
            </Form>
          )}
        </Formik>
        <LoadContainer>
          {!products || products.length === 0 && (
            <Button forth onClick={(e) => e.preventDefault()}>
              NO MORE ITEMS
            </Button>
          )}
        </LoadContainer>
        {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
      </Content>
      {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
    </Layout>
  );
};